import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { PaginationParams } from '@/common/types';
import { API_URL } from '@/dtos';
import { LoginHistory, LoginHistoryPayload } from '@/modules/LoginHistory/loginHistory.types';
import { formatDateRange } from '@/utils/modifiers';

export interface ContactLoginHistoryPayload extends LoginHistoryPayload {}

interface LoginHistoryQueryParams extends Partial<PaginationParams> {
  contactId: string | null;
  startDate: Date | null;
  endDate: Date | null;
}

const useGetContactLoginHistoryQuery = ({
  contactId,
  startDate,
  endDate,
  page,
  perPage,
}: LoginHistoryQueryParams) => {
  const [from, to] = formatDateRange([startDate, endDate]);

  const { data, isLoading } = useQuery(
    // TODO: type is missing
    [API_URL.LOGIN_HISTORY_ADMIN, contactId, startDate, endDate, page, perPage],
    () =>
      api.get(API_URL.LOGIN_HISTORY_ADMIN, {
        params: {
          contact_id: contactId,
          start_date: from,
          end_date: to,
          page: page && page >= 0 ? page - 1 : 0,
          size: perPage || 50,
        },
      }),
    {
      enabled: !!contactId,
    }
  );

  const contactLoginHistory: LoginHistory[] = useMemo(() => {
    return (
      data?.data?.content?.map((loginHistory: ContactLoginHistoryPayload) => ({
        id: loginHistory?.id,
        username: loginHistory?.username,
        eventType: loginHistory?.event_type,
        statusType: loginHistory?.status_type,
        failureReasonType: loginHistory?.failure_reason_type,
        personalEmail: loginHistory?.personal_email,
        employeeIds: loginHistory?.employee_ids,
        contactId: loginHistory?.contact_id,
        createdAt: loginHistory?.created_at,
        sourceType: loginHistory?.source_type,
        ipAddress: loginHistory?.ip_address,
        geolocation: loginHistory?.geolocation,
        userAgent: loginHistory?.user_agent,
        mfaStatusType: loginHistory?.mfa_status_type,
        organizationId: loginHistory?.organization_id,
        organizationPath: loginHistory?.organization_path,
      })) || []
    );
  }, [data]);

  return {
    contactLoginHistory,
    isLoading,
    total: data?.data?.totalElements || 0,
  };
};

export default useGetContactLoginHistoryQuery;
